import React, { useState } from 'react';
import { Role } from '../../core/api/models';
import '../../styles/details.scss';
import '../../styles/settings.scss';

const RoleList: React.FunctionComponent<{
  loadDetails: (id: string) => void;
  roles: Role[];
  selectedRoleId: string | undefined;
  setSelectedRoleId: (id?: string) => void;
  setUserLogs: (userLogs: boolean) => void;
  userLogs: boolean;
}> = (props) => {
  const { selectedRoleId, setSelectedRoleId, setUserLogs } = props;
  return (
    <>
      <ul className="list-unstyled mb-0">
        {props.roles?.map((role, index) => {
          return (
            <li
              key={index}
              className={`border-bottom px-3 py-2 d-flex align-items-center cursor-pointer ${
                selectedRoleId === role?._id ? 'bg-primary text-white' : ''
              }`}
              onClick={() => {
                setSelectedRoleId(role?._id)
                setUserLogs(false)
              }}
            >
              <div className="py-2">
                <h6 className="mb-0">{role.name}</h6>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default RoleList;
